module.exports = __webpack_public_path__ + "static/coverr-oil-rig-attraction-1567244954839-0b4cdf6224fccd322454b91f44ef8883.mp4";